let loader;
const listLoaders = {};
if (typeof window !== 'undefined') {
  loader = url => {
    listLoaders[url] = listLoaders[url] || fetch(url).then(res => {
      return res.text();
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error(err);
      listLoaders[url] = new Promise(resolve => {
        resolve(undefined);
      });
    });
    return listLoaders[url];
  };
} else {
  loader = url => {
    const fetch = require('node-fetch').default;

    /* возможны url без протокола - //some.site - заменяем на протокол http для корректного парсинга */
    const fixedUrl = url.replace(/^\/\//, 'http://');
    listLoaders[url] = listLoaders[url] || fetch(fixedUrl, {
      timeout: 2000
    }).then(res => {
      if (res.status !== 200) {
        throw new Error(`Status code is ${res.status} - ${res.statusText} for ${url}`);
      }
      return res.text();
    }).catch(err => {
      listLoaders[url] = new Promise(resolve => {
        resolve(undefined);
      });
      throw err;
    });
    return listLoaders[url];
  };
}
export const fileLoader = url => {
  return loader(url);
};